
define('template!ordersDetailOrderClientCommentsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="comments-ctn"></div>     \n<div class="no-comments" style="display:none;">-</div> \n';

}
return __p
};});

